import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '../views/Main.vue';
import Home from '../views/Home.vue'
import Inviter from '../views/Inviter.vue'
import Sales from '../views/Sales.vue'
import Cooperation from '../views/Cooperation.vue'
import HelpCentre from '../views/HelpCentre.vue'
import login from '../views/login.vue'
import user from '../views/User.vue'
import Newsdetail from '../views/Newsdetail.vue';
import Cardschool from '../views/Cardschool.vue';
import Search from '../views/search-result.vue';
import webView from '../views/webView.vue';
import Scan from '../views/Scan.vue';
import { createWebHashHistory } from 'vue-router'
import Cokie from "js-cookie";
let originPush = VueRouter.prototype.push;
let originReplace = VueRouter.prototype.replace;
VueRouter.prototype.push = function (location, resolve, reject) {
    if (resolve && reject) {   
        originPush.call(this, location, resolve, reject)
    } else {   
        originPush.call(this, location, () => { }, () => { })
    }
}
 
VueRouter.prototype.replace = function (location, resolve, reject) {
  if (resolve && reject) {
      originReplace.call(this, location, resolve, reject)
  } else {
      originReplace.call(this, location, () => { }, () => { })
  }
}
Vue.use(VueRouter)
const routes = [
    {
        path:'/',
        component:Main,
        redirect:'/Home',
        children:[
            { path: 'Home', name:'Home', component: Home },
            { path: 'Inviter', name:'Inviter', component: Inviter },
            { path: 'Sales', name:'Sales', component: Sales },
            { path: 'Cooperation', name:'Cooperation', component: Cooperation },
            { path: 'HelpCentre', name:'HelpCentre', component: HelpCentre },
            { path: 'user', name:'user', component: user },
            { path: 'newsdetail', name:'Newsdetail', component: Newsdetail },
            { path: 'cardschool', name:'Cardschool', component: Cardschool },
            { path: 'search', name:'search', component: Search },
            { path: 'webView', name:'webView', component: webView },
        ]
    },
    {
        path: "/login",
        component: () => import("@/views/login"),
        hidden: false
      },

      {
        path: "/Scan",
        component: () => import("@/views/Scan"),
        hidden: false
      },
  ]
  //3:创建实例
  const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes 
  })
  // 对外暴露
  export default router
  

